import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableCustomerRoutes = Loadable(
  './CustomerRoutes',
  () => import(/* webpackChunkName: "Customer" */ './CustomerRoutes'),
  () => [(require as any).resolveWeak('./CustomerRoutes')]
);
